import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { SaleTargetInfo } from '../model/SaleTargetInfo.model';
import { SaleTeamInfo } from '../model/SaleTeamInfo.model';
import { SaleTargetByAssetInfo } from '../model/SaleTargetByAssetInfo.model';
import { AssetGroupInfo } from '../model/AssetGroupInfo.model';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { LookupInfo } from '../model/lookup.model';
import * as XLSX from 'xlsx';

// 1. Interface สำหรับข้อมูลประเภทสินทรัพย์ (Asset Type)

// 2. Interface สำหรับข้อมูลทีมขายและพนักงาน
export interface SaleTeamEmployeeInfo {
  SaleTeamCode: string;
  SaleTeamName: string;
  EmployeeCode: string;
  EmployeeName: string;
}

@Component({
  selector: 'app-sale-target-management',
  templateUrl: './sale-target-management.component.html',
  styleUrls: ['./sale-target-management.component.css']
})
export class SaleTargetManagementComponent implements OnInit {
  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  baseurl: string;

  yearOptions: string[] = [];
  quarterOptions: string[] = [];
  monthOptions: { value: string; label: string }[] = [];

  earliestTarget: SaleTargetInfo;

  // Search variables
  periodSearch: string = 'YEAR';
  yearSearch: string = null;
  quarterSearch: string = null;
  monthSearch: string = null;
  txtSearchSaleTeam: string = null;
  txtSearchSaleTeamMember: string = null;
  txtSaleTeamName: string = null;

  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];

  SaleTargetByAssetList: SaleTargetByAssetInfo[] = []

  editedAssetTypeValues: any = {}
  originalAssetTypeValues: any = {};
  processedAssetTypeTeamData: any[] = [];


  // Main Data
  SaleTargetList: SaleTargetInfo[] = [];
  processedEmployeeData: any[] = [];
  processedTeamData: any[] = [];
  processedTeamOnlyData: any[] = [];

  // Table edit mode properties
  tableEditMode: boolean = false;
  teamTableEditMode: boolean = false;
  editedValues: any = {};
  originalValues: any = {};
  teamEditedValues: any = {};
  teamOriginalValues: any = {};

  tableAssetTypeEditMode: boolean = false;
  editedAssetValues: any = {};

  // Edit form properties
  editMode: boolean = false;
  selectedTarget: SaleTargetInfo = {
    SaleTargetId: 0,
    SaleTargetTeamCode: '',
    SaleTargetTeamName: '',
    SaleTargetTeamSeq: '',
    SaleTargetEmpCode: '',
    SaleTargetEmpName: '',
    SaleTargetMonth: '',
    SaleTargetQuarter: '',
    SaleTargetYear: '',
    SaleTargetPeriod: 'YEAR',
    SaleTargetAmount: 0,
    SaleTargetActualAmount: 0,
    CreateDate: null,
    CreateBy: '',
    UpdateDate: null,
    UpdateBy: '',
    rowFetch: 0,
    rowOFFSet: 0,
    itemTotal: 0,
    RequesterEmpCode: '',
    SaleTargetFlagNewCust: 'N',
    SaleTargetAssetTypeCode: '',
    SaleTargetAssetTypeName: ''
  };

  IsModalOn = false;

  modalPeriodSelected = "YEAR";

  // Sale Team properties
  selectedTeam: any = null;
  selectedTeamMember: any = null;
  teamOptions: SaleTeamMappingEmployeeInfo[] = [];
  teamMemberOptions: SaleTeamMappingEmployeeInfo[] = [];

  // Zone pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number = 0;
  public totalPages: number = 0;
  public totalItems: number = 0;
  public environment: number = 999999;

  // สำหรับข้อมูลที่ใช้ render ใน mat-tab Asset Type
  tableEditModeAsset: boolean = false;
  processedAssetTypeData: any[] = [];
  excelData: any[] = [];
  AssetGroupMasterList: AssetGroupInfo[] = [];
  AssetCategoryMasterList: AssetCategoryInfoInfo[] = [];
  AssetTypeMasterList: AssetTypeInfo[] = [];
  isMat: boolean = false;
  isMatSaleTargetTeam: boolean = false;
  isUpload: boolean = false;

  AssetList: LookupInfo[] = [];
  ddlAsset: string

  SaleTargetAssetCategoryList: SaleTargetByAssetInfo[] = []; // Binding For Mat-tab: Sale Target By Asset
  SumYearAmount: number = 0;

  assetEditMode = false;
  originalAssetMonthly: { [key: string]: number } = {};
  categoryBudgetInput: { [key: string]: number } = {};
  editedAssetMonthly: { [key: string]: number } = {};
  monthNames: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  currentAssetMasterList: any[] = [];
  currentSaleTargetList: any[] = [];
  currentAssetCodeField: string = '';
  currentAssetNameField: string = '';
  draftEditedAssetMonthly: { [key: string]: number } = {};
  isSubmitted: any;

  EmpMappingSaleTargetTeamList: SaleTeamMappingEmployeeInfo[] = [];

  @ViewChild('customerTargetExcelFileInput') customerTargetExcelFileInput: ElementRef;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit(): Promise<void> {

    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }
    await this.loadEarliestTarget();

    await this.generateYearOptions();
    await this.generateQuarterOptions();
    await this.generateMonthOptions();
    await this.LoadAssetList();

    await this.LoadSaleTeam();
    await this.LoadAssetGroupMasterList();
    await this.LoadAssetCategoryMasterList();
    await this.LoadAssetTypeMasterList();
    await this.LoadSaleTargetAssetCategoryList();

    this.ddlAsset = "AC"; // Set init Option for Set
    this.onChangeddlAsset(this.ddlAsset);

  }

  async generateYearOptions(): Promise<void> {
    const currentYear = new Date().getFullYear();
    this.yearOptions = [];
    
    let startYear = currentYear;
    if (this.earliestTarget && this.earliestTarget.SaleTargetYear) {
      startYear = parseInt(this.earliestTarget.SaleTargetYear);
    }

    // Generate years from earliest year to current year + 1
    for (let year = startYear; year <= currentYear + 1; year++) {
      this.yearOptions.push(year.toString());
    }

    this.yearSearch = this.yearOptions[0];
    this.LoadSaleTarget(true);
    this.LoadSaleTargetByAsset(true);
  }

  generateQuarterOptions(): void {
    this.quarterOptions = [
      'Q1',
      'Q2',
      'Q3',
      'Q4'
    ];
  }

  generateMonthOptions(): void {
    this.monthOptions = [
      { value: "1", label: 'January' },
      { value: "2", label: 'February' },
      { value: "3", label: 'March' },
      { value: "4", label: 'April' },
      { value: "5", label: 'May' },
      { value: "6", label: 'June' },
      { value: "7", label: 'July' },
      { value: "8", label: 'August' },
      { value: "9", label: 'September' },
      { value: "10", label: 'October' },
      { value: "11", label: 'November' },
      { value: "12", label: 'December' }
    ];
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }


  resetSearch(){
    //this.yearSearch = null;
    this.quarterSearch = null;
    this.monthSearch = null;
    // this.txtSearchSaleTeam = null;
    // this.txtSearchSaleTeamMember = null;
  }

  async LoadSaleTarget(search: boolean = false) {
    const foundTeam = this.SaleTeamList.find(team => team.SaleTeamCode === this.txtSearchSaleTeam);

    if (foundTeam) {
        this.txtSaleTeamName = foundTeam.SaleTeamName.trim();
        //console.log('Found SaleTeamName:', this.txtSaleTeamName);
    } 

    if(!search){
      this.SaleTargetList = [];
      this.txtSearchSaleTeam = null;
      this.txtSearchSaleTeamMember = null;
      this.yearSearch = null;
      this.resetSearch();
      return;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['RequesterEmpCode'] = this.checkUndefinedString(this._EmpCode);
      objectjson['SaleTargetTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
      objectjson['SaleTargetEmpCode'] = this.checkUndefinedString(this.txtSearchSaleTeamMember);
      objectjson['SaleTargetMonth'] = this.checkUndefinedString(this.monthSearch);
      objectjson['SaleTargetQuarter'] = this.checkUndefinedString(this.quarterSearch);
      objectjson['SaleTargetYear'] = this.checkUndefinedString(this.yearSearch);
      //objectjson['rowFetch'] = this.environment;
      //objectjson['rowOFFSet'] = ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * this.environment;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTargetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTargetList = data;

          this.totalItems = data.length;

          if(this.SaleTargetList.length <= 0){
            this.currentPageNumber = 0;
          }else{
            if(this.currentPageNumber == 0) this.currentPageNumber = 1;

            this.totalItems = Number(this.SaleTargetList[0].itemTotal);
          }
          // Calculate total pages
          this.totalPages = Math.ceil(this.totalItems / this.environment);
          
          // Process data for table display
          this.processDataForTable();
          this.LoadSaleTargetByAsset(search);
          this.LoadSaleTargetAssetCategoryList();
        }).catch((error) => {
          console.error('Error loading sale targets:', error);
        });
    }
  }

  // Pagination callback
  LoadSaleTargetPage(page: any): void {
    this.currentPageNumber = page.currentPageNumber;
    this.LoadSaleTarget(true);
  }

  async LoadSaleTeam() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data

          if (this.SaleTeamList.length > 0) {
            this.txtSearchSaleTeam = this.SaleTeamList[0].SaleTeamCode;
            this.txtSaleTeamName = this.SaleTeamList[0].SaleTeamName;
          }

          console.log('SaleTeamList', this.SaleTeamList);
        });
    }
  }

  async LoadSaleTeamUnders() {

    this.SaleTeamUnderList = [];
    this.txtSearchSaleTeamMember = null;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
      //objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['AssignedSellerOnly'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamUnderList = data
        });
    }
  }

  async loadEarliestTarget() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTargetInfo>(this.baseurl + "SaleTarget/GetSaleTargetEarliest", strjson, httpOptions)
        .toPromise().then((data) => {
          this.earliestTarget = data

          //console.log(this.SaleTeamList);
        });

    } catch (error) {
      console.error('Error loading team options:', error);
    }
  }

  isSearchButtonDisabled(): boolean {
    // if (!this.txtSearchSaleTeam) {
    //   return true;
    // }

    switch (this.periodSearch) {
      case 'YEAR':
        return !this.yearSearch;
      case 'QUARTER':
        return !this.yearSearch || !this.quarterSearch;
      case 'MONTH':
        return !this.yearSearch || !this.monthSearch;
      default:
        return false;
    }
  }

  onPeriodChange() {
    if (this.modalPeriodSelected === 'YEAR') {
      this.selectedTarget.SaleTargetQuarter = '';
      this.selectedTarget.SaleTargetMonth = '';
    } else if (this.modalPeriodSelected === 'QUARTER') {
      this.selectedTarget.SaleTargetMonth = '';
    }
  }

  async editTarget(id: number) {
    this.IsModalOn = true;
    this.modalPeriodSelected = "YEAR";

    if (id > 0) {
      this.editMode = true;
      const target = this.SaleTargetList.find(x => x.SaleTargetId === id);
      if (target) {
        this.selectedTarget = { ...target };

        this.modalPeriodSelected = "YEAR";
        if(this.selectedTarget.SaleTargetQuarter != null && this.selectedTarget.SaleTargetQuarter != undefined && this.selectedTarget.SaleTargetQuarter != '') this.modalPeriodSelected = "QUARTER";
        if(this.selectedTarget.SaleTargetMonth != null && this.selectedTarget.SaleTargetMonth != undefined && this.selectedTarget.SaleTargetMonth != '') this.modalPeriodSelected = "MONTH";
        
        // Load team and member options
        await this.loadTeamOptions();
        this.selectedTeam = this.teamOptions.find(t => t.SaleTeamCode === target.SaleTargetTeamCode).SaleTeamCode;
        if (this.selectedTeam) {
          await this.loadTeamMemberOptions(this.selectedTeam.SaleTeamCode);
          this.selectedTeamMember = this.teamMemberOptions.find(m => m.EmployeeCode === target.SaleTargetEmpCode);
        }
      }
    } else {
      this.editMode = false;
      this.selectedTarget = {
        SaleTargetId: 0,
        SaleTargetTeamCode: '',
        SaleTargetTeamName: '',
        SaleTargetTeamSeq: '',
        SaleTargetEmpCode: '',
        SaleTargetEmpName: '',
        SaleTargetMonth: '',
        SaleTargetQuarter: '',
        SaleTargetYear: '',
        SaleTargetPeriod: 'YEAR',
        SaleTargetAmount: 0,
        SaleTargetActualAmount: 0,
        CreateDate: null,
        CreateBy: '',
        UpdateDate: null,
        UpdateBy: '',
        rowFetch: 0,
        rowOFFSet: 0,
        itemTotal: 0,
        RequesterEmpCode: this._EmpCode,
        SaleTargetFlagNewCust: 'N',
        SaleTargetAssetTypeCode: '',
        SaleTargetAssetTypeName: ''
      };
      
      // Load team options for new target
      await this.loadTeamOptions();
    }
  }

  async deleteTarget(id: number){
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTargetId'] = id;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post(this.baseurl + "SaleTarget/DeleteSaleTarget", strjson, httpOptions)
        .toPromise().then(() => {
          alert('Sale target deleted successfully');
          this.LoadSaleTarget(true);
        });
    } catch (error) {
      console.error('Error deleting sale target:', error);
      alert('Failed to delete sale target');
    }
  }

  async loadTeamOptions() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.teamOptions = data

          //console.log(this.SaleTeamList);
        });

    } catch (error) {
      console.error('Error loading team options:', error);
    }
  }

  async loadTeamMemberOptions(teamCode: string) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      //console.log(this.selectedTeam)
      objectjson['SaleTeamCode'] = this.checkUndefinedString(this.selectedTeam);
      //objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['AssignedSellerOnly'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.teamMemberOptions = data

        });

    } catch (error) {
      console.error('Error loading team member options:', error);
    }
  }

  onTeamChange(team: any) {
    if (team) {
      this.selectedTarget.SaleTargetTeamCode = team.SaleTeamCode;
      this.selectedTarget.SaleTargetTeamName = team.SaleTeamName;
      this.selectedTarget.SaleTargetTeamSeq = team.SaleTeamSeq;
      
      // Load team members when team changes
      this.loadTeamMemberOptions(team.SaleTeamCode);
    } else {
      this.selectedTarget.SaleTargetTeamCode = '';
      this.selectedTarget.SaleTargetTeamName = '';
      this.selectedTarget.SaleTargetTeamSeq = '';
      this.teamMemberOptions = [];
      this.selectedTeamMember = null;
    }
  }

  onTeamMemberChange(member: any) {
    if (member) {
      this.txtSearchSaleTeamMember = member.EmployeeCode;
    }
  }
  
  processDataForTable() {
    // First, group by team code
    const teamMap = new Map<string, any>();
    const teamOnlyMap = new Map<string, any>();
    
    // Filter the data based on the selected team and team member
    let filteredList = [...this.SaleTargetList]; // Create a copy to avoid modifying the original
    
    // Apply team filter if selected
    if (this.txtSearchSaleTeam) {
      console.log('Filtering by team:', this.txtSearchSaleTeam);
      filteredList = filteredList.filter(item => item.SaleTargetTeamCode === this.txtSearchSaleTeam);
    }
    
    // Apply team member filter if selected
    if (this.txtSearchSaleTeamMember) {
      console.log('Filtering by team member:', this.txtSearchSaleTeamMember);
      filteredList = filteredList.filter(item => item.SaleTargetEmpCode === this.txtSearchSaleTeamMember);
    }
    
    // Group by team, then by employee
    filteredList.forEach(item => {
      const teamKey = item.SaleTargetTeamCode;
      const empKey = item.SaleTargetEmpCode;
      
      // Process team-level data (where employee code is empty or null)
      if (!empKey || empKey.trim() === '') {
        // Create team-only entry if it doesn't exist
        if (!teamOnlyMap.has(teamKey)) {
          teamOnlyMap.set(teamKey, {
            teamCode: item.SaleTargetTeamCode,
            teamName: item.SaleTargetTeamName,
            oldCustomer: {
              months: Array(12).fill(null),  // Jan-Dec
              quarters: Array(4).fill(null), // Q1-Q4
              year: null                     // Total
            },
            newCustomer: {
              months: Array(12).fill(null),  // Jan-Dec
              quarters: Array(4).fill(null), // Q1-Q4
              year: null                     // Total
            }
          });
        }
        
        const teamOnlyData = teamOnlyMap.get(teamKey);
        const isNewCustomer = item.SaleTargetFlagNewCust === 'Y';
        const targetData = isNewCustomer ? teamOnlyData.newCustomer : teamOnlyData.oldCustomer;
        
        // Process monthly data
        if (item.SaleTargetMonth) {
          const monthIndex = parseInt(item.SaleTargetMonth) - 1; // Convert 1-12 to 0-11
          if (monthIndex >= 0 && monthIndex < 12) {
            targetData.months[monthIndex] = item.SaleTargetAmount;
          }
        }
        
        // Process quarterly data
        if (item.SaleTargetQuarter) {
          const quarterMap = { 'Q1': 0, 'Q2': 1, 'Q3': 2, 'Q4': 3 };
          const quarterIndex = quarterMap[item.SaleTargetQuarter];
          if (quarterIndex !== undefined) {
            targetData.quarters[quarterIndex] = item.SaleTargetAmount;
          }
        }
        
        // Process yearly data
        if (!item.SaleTargetMonth && !item.SaleTargetQuarter && item.SaleTargetYear) {
          targetData.year = item.SaleTargetAmount;
        }
        
        // Skip processing employee data for team-only entries
        return;
      }
      
      // Process employee-level data
      // Create team entry if it doesn't exist
      if (!teamMap.has(teamKey)) {
        teamMap.set(teamKey, {
          teamCode: item.SaleTargetTeamCode,
          teamName: item.SaleTargetTeamName,
          employees: new Map<string, any>()
        });
      }
      
      const teamData = teamMap.get(teamKey);
      
      // Create a composite key that includes both employee code and team code
      // This ensures that the same employee in different teams is treated as separate entries
      const compositeKey = `${empKey}_${teamKey}`;
      
      // Create employee entry if it doesn't exist
      if (!teamData.employees.has(compositeKey)) {
        teamData.employees.set(compositeKey, {
          empCode: item.SaleTargetEmpCode,
          empName: item.SaleTargetEmpName,
          teamCode: item.SaleTargetTeamCode,
          teamName: item.SaleTargetTeamName,
          oldCustomer: {
            months: Array(12).fill(null),  // Jan-Dec
            quarters: Array(4).fill(null), // Q1-Q4
            year: null                     // Total
          },
          newCustomer: {
            months: Array(12).fill(null),  // Jan-Dec
            quarters: Array(4).fill(null), // Q1-Q4
            year: null                     // Total
          }
        });
      }
      
      const empData = teamData.employees.get(compositeKey);
      const isNewCustomer = item.SaleTargetFlagNewCust === 'Y';
      const targetData = isNewCustomer ? empData.newCustomer : empData.oldCustomer;
      
      // Process monthly data
      if (item.SaleTargetMonth) {
        const monthIndex = parseInt(item.SaleTargetMonth) - 1; // Convert 1-12 to 0-11
        if (monthIndex >= 0 && monthIndex < 12) {
          targetData.months[monthIndex] = item.SaleTargetAmount;
        }
      }
      
      // Process quarterly data
      if (item.SaleTargetQuarter) {
        const quarterMap = { 'Q1': 0, 'Q2': 1, 'Q3': 2, 'Q4': 3 };
        const quarterIndex = quarterMap[item.SaleTargetQuarter];
        if (quarterIndex !== undefined) {
          targetData.quarters[quarterIndex] = item.SaleTargetAmount;
        }
      }
      
      // Process yearly data
      if (!item.SaleTargetMonth && !item.SaleTargetQuarter && item.SaleTargetYear) {
        targetData.year = item.SaleTargetAmount;
      }
    });
    
    // Convert nested maps to arrays for template rendering
    const processedTeamData = [];
    
    teamMap.forEach(team => {
      const teamEmployees = Array.from(team.employees.values());
      processedTeamData.push({
        teamCode: team.teamCode,
        teamName: team.teamName,
        employees: teamEmployees
      });
    });
    
    // For backward compatibility, also keep the flat employee list
    // But ensure we don't have duplicates by using a Map with composite keys
    const employeeMap = new Map<string, any>();
    processedTeamData.forEach(team => {
      team.employees.forEach(emp => {
        const compositeKey = `${emp.empCode}_${emp.teamCode}`;
        employeeMap.set(compositeKey, emp);
      });
    });
    
    const allEmployees = Array.from(employeeMap.values());
    
    // Convert team-only map to array for template rendering
    this.processedTeamOnlyData = Array.from(teamOnlyMap.values());
    this.processedTeamData = processedTeamData;

    console.log(this.processedTeamData)
    this.processedEmployeeData = allEmployees;
  }

  async saveTarget() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        alert('Failed to get authentication token');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if(this.editMode){
        this.selectedTarget.UpdateBy = this.checkUndefinedString(this._EmpCode);
      }else{
        this.selectedTarget.CreateBy = this.checkUndefinedString(this._EmpCode);
      }

      this.selectedTarget.SaleTargetTeamCode = this.selectedTeam;
      this.selectedTarget.SaleTargetEmpCode = this.selectedTeamMember;
      this.selectedTarget.SaleTargetPeriod = this.modalPeriodSelected;

      const strjson = JSON.stringify(this.selectedTarget);

      let url = this.baseurl + "SaleTarget/SetSaleTarget";

      await this.httpClient.post(url, strjson, httpOptions)
        .toPromise();

      alert('Sale target set successfully');
      this.periodSearch = this.modalPeriodSelected;
      this.txtSearchSaleTeam = this.selectedTeam;
      this.txtSearchSaleTeamMember = this.selectedTeamMember;
      this.yearSearch = this.selectedTarget.SaleTargetYear;
      this.quarterSearch = this.selectedTarget.SaleTargetQuarter;
      this.monthSearch = this.selectedTarget.SaleTargetMonth;
      if(this.SaleTeamUnderList.length <= 0) await this.LoadSaleTeamUnders();
      this.closeModal();
      await this.LoadSaleTarget(true);
    } catch (error) {
      console.error('Error saving sale target:', error);
      alert('Failed to save sale target');
    }
  }

  closeModal() {
    this.IsModalOn = false;

    //this.selectedTarget = null;
    this.selectedTeam = null;
    this.selectedTeamMember = null;
    this.teamMemberOptions = [];

    const modal = document.getElementById('saleTargetModal');
    if (modal) {
      modal.style.display = 'none';
    }
  }
  toggleTableEditMode() {
    // Get the active tab index
    const tabElements = document.querySelectorAll('mat-tab-body.mat-tab-body-active');
    const isTeamTab = tabElements.length > 0 && tabElements[0].getAttribute('id')?.includes('mat-tab-content-0-1');
    
    if (isTeamTab) {
      // Team tab
      if (!this.teamTableEditMode) {
        this.teamTableEditMode = true;
        this.initializeTeamEditValues();
      } else {
        this.cancelTeamTableEdit();
      }
    } else {
      // Member tab
      if (!this.tableEditMode) {
        this.tableEditMode = true;
        this.initializeEditValues();
      } else {
        this.cancelTableEdit();
      }
    }
  }

  toggleTeamTableEditMode() {
    if (!this.teamTableEditMode) {
      // Entering edit mode - store original values
      this.teamTableEditMode = true;
      this.initializeTeamEditValues();
    } else {
      // Exiting edit mode without saving
      this.cancelTeamTableEdit();
    }
  }

  initializeEditValues() {
    this.editedValues = {};
    this.originalValues = {};
    
    // Initialize employee data
    this.processedTeamData.forEach(team => {
      team.employees.forEach(employee => {
        // Create composite key with employee code and team code
        const compositeKey = `${employee.empCode}_${employee.teamCode}`;
        
        // Old customer data
        for (let i = 0; i < 12; i++) {
          const oldMonthKey = `${compositeKey}_old_month_${i}`;
          const oldMonthValue = employee.oldCustomer.months[i] || 0;
          this.editedValues[oldMonthKey] = oldMonthValue;
          this.originalValues[oldMonthKey] = oldMonthValue;
        }
        
        for (let i = 0; i < 4; i++) {
          const oldQuarterKey = `${compositeKey}_old_quarter_${i}`;
          const oldQuarterValue = employee.oldCustomer.quarters[i] || 0;
          this.editedValues[oldQuarterKey] = oldQuarterValue;
          this.originalValues[oldQuarterKey] = oldQuarterValue;
        }
        
        const oldYearKey = `${compositeKey}_old_year`;
        const oldYearValue = employee.oldCustomer.year || 0;
        this.editedValues[oldYearKey] = oldYearValue;
        this.originalValues[oldYearKey] = oldYearValue;
        
        // New customer data
        for (let i = 0; i < 12; i++) {
          const newMonthKey = `${compositeKey}_new_month_${i}`;
          const newMonthValue = employee.newCustomer.months[i] || 0;
          this.editedValues[newMonthKey] = newMonthValue;
          this.originalValues[newMonthKey] = newMonthValue;
        }
        
        for (let i = 0; i < 4; i++) {
          const newQuarterKey = `${compositeKey}_new_quarter_${i}`;
          const newQuarterValue = employee.newCustomer.quarters[i] || 0;
          this.editedValues[newQuarterKey] = newQuarterValue;
          this.originalValues[newQuarterKey] = newQuarterValue;
        }
        
        const newYearKey = `${compositeKey}_new_year`;
        const newYearValue = employee.newCustomer.year || 0;
        this.editedValues[newYearKey] = newYearValue;
        this.originalValues[newYearKey] = newYearValue;
      });
    });
    
    // Initialize team-only data
    this.processedTeamOnlyData.forEach(team => {
      // Old customer data
      for (let i = 0; i < 12; i++) {
        const oldMonthKey = `${team.teamCode}_team_old_month_${i}`;
        const oldMonthValue = team.oldCustomer.months[i] || 0;
        this.editedValues[oldMonthKey] = oldMonthValue;
        this.originalValues[oldMonthKey] = oldMonthValue;
      }
      
      for (let i = 0; i < 4; i++) {
        const oldQuarterKey = `${team.teamCode}_team_old_quarter_${i}`;
        const oldQuarterValue = team.oldCustomer.quarters[i] || 0;
        this.editedValues[oldQuarterKey] = oldQuarterValue;
        this.originalValues[oldQuarterKey] = oldQuarterValue;
      }
      
      const oldYearKey = `${team.teamCode}_team_old_year`;
      const oldYearValue = team.oldCustomer.year || 0;
      this.editedValues[oldYearKey] = oldYearValue;
      this.originalValues[oldYearKey] = oldYearValue;
      
      // New customer data
      for (let i = 0; i < 12; i++) {
        const newMonthKey = `${team.teamCode}_team_new_month_${i}`;
        const newMonthValue = team.newCustomer.months[i] || 0;
        this.editedValues[newMonthKey] = newMonthValue;
        this.originalValues[newMonthKey] = newMonthValue;
      }
      
      for (let i = 0; i < 4; i++) {
        const newQuarterKey = `${team.teamCode}_team_new_quarter_${i}`;
        const newQuarterValue = team.newCustomer.quarters[i] || 0;
        this.editedValues[newQuarterKey] = newQuarterValue;
        this.originalValues[newQuarterKey] = newQuarterValue;
      }
      
      const newYearKey = `${team.teamCode}_team_new_year`;
      const newYearValue = team.newCustomer.year || 0;
      this.editedValues[newYearKey] = newYearValue;
      this.originalValues[newYearKey] = newYearValue;
    });
  }

  cancelTableEdit() {
    // Get the active tab index
    const tabElements = document.querySelectorAll('mat-tab-body.mat-tab-body-active');
    const isTeamTab = tabElements.length > 0 && tabElements[0].getAttribute('id')?.includes('mat-tab-content-0-1');

    console.log('isTeamTab', tabElements);
    
    if (isTeamTab) {
      // Team tab
      this.teamTableEditMode = false;
      this.teamEditedValues = {};
      this.teamOriginalValues = {};
    } else {
      // Member tab
      this.tableEditMode = false;
      this.editedValues = {};
      this.originalValues = {};
    }
  }
  
  cancelTeamTableEdit() {
    this.teamTableEditMode = false;
    this.teamEditedValues = {};
    this.teamOriginalValues = {};
  }
  
  initializeTeamEditValues() {
    this.teamEditedValues = {};
    this.teamOriginalValues = {};
    
    // Initialize team data
    this.processedTeamOnlyData.forEach(team => {
      const teamKey = team.teamCode;
      
      // Old customer data
      for (let i = 0; i < 12; i++) {
        const oldMonthKey = `${teamKey}_old_month_${i}`;
        const oldMonthValue = team.oldCustomer.months[i] || 0;
        this.teamEditedValues[oldMonthKey] = oldMonthValue;
        this.teamOriginalValues[oldMonthKey] = oldMonthValue;
      }
      
      for (let i = 0; i < 4; i++) {
        const oldQuarterKey = `${teamKey}_old_quarter_${i}`;
        const oldQuarterValue = team.oldCustomer.quarters[i] || 0;
        this.teamEditedValues[oldQuarterKey] = oldQuarterValue;
        this.teamOriginalValues[oldQuarterKey] = oldQuarterValue;
      }
      
      const oldYearKey = `${teamKey}_old_year`;
      const oldYearValue = team.oldCustomer.year || 0;
      this.teamEditedValues[oldYearKey] = oldYearValue;
      this.teamOriginalValues[oldYearKey] = oldYearValue;
      
      // New customer data
      for (let i = 0; i < 12; i++) {
        const newMonthKey = `${teamKey}_new_month_${i}`;
        const newMonthValue = team.newCustomer.months[i] || 0;
        this.teamEditedValues[newMonthKey] = newMonthValue;
        this.teamOriginalValues[newMonthKey] = newMonthValue;
      }
      
      for (let i = 0; i < 4; i++) {
        const newQuarterKey = `${teamKey}_new_quarter_${i}`;
        const newQuarterValue = team.newCustomer.quarters[i] || 0;
        this.teamEditedValues[newQuarterKey] = newQuarterValue;
        this.teamOriginalValues[newQuarterKey] = newQuarterValue;
      }
      
      const newYearKey = `${teamKey}_new_year`;
      const newYearValue = team.newCustomer.year || 0;
      this.teamEditedValues[newYearKey] = newYearValue;
      this.teamOriginalValues[newYearKey] = newYearValue;
    });
  }
  
  async saveTeamTableEdit() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) return;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare data for saving
      const updatedTargets = [];
      
      this.processedTeamOnlyData.forEach(team => {
        const teamKey = team.teamCode;
        
        // Process monthly data
        for (let i = 0; i < 12; i++) {
          const oldMonthKey = `${teamKey}_old_month_${i}`;
          const newMonthKey = `${teamKey}_new_month_${i}`;
          
          const oldMonthValue = this.teamEditedValues[oldMonthKey];
          const newMonthValue = this.teamEditedValues[newMonthKey];
          
          // Only add to update list if value has changed
          if (oldMonthValue !== this.teamOriginalValues[oldMonthKey]) {
            updatedTargets.push({
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: (i + 1).toString(),
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'MONTH',
              SaleTargetAmount: oldMonthValue,
              SaleTargetFlagNewCust: 'N',
              RequesterEmpCode: this._EmpCode
            });
          }
          
          if (newMonthValue !== this.teamOriginalValues[newMonthKey]) {
            updatedTargets.push({
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: (i + 1).toString(),
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'MONTH',
              SaleTargetAmount: newMonthValue,
              SaleTargetFlagNewCust: 'Y',
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        // Process quarterly data
        for (let i = 0; i < 4; i++) {
          const oldQuarterKey = `${teamKey}_old_quarter_${i}`;
          const newQuarterKey = `${teamKey}_new_quarter_${i}`;
          
          const oldQuarterValue = this.teamEditedValues[oldQuarterKey];
          const newQuarterValue = this.teamEditedValues[newQuarterKey];
          
          const quarterMap = { 0: 'Q1', 1: 'Q2', 2: 'Q3', 3: 'Q4' };
          
          // Only add to update list if value has changed
          if (oldQuarterValue !== this.teamOriginalValues[oldQuarterKey]) {
            updatedTargets.push({
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: '',
              SaleTargetQuarter: quarterMap[i],
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'QUARTER',
              SaleTargetAmount: oldQuarterValue,
              SaleTargetFlagNewCust: 'N',
              RequesterEmpCode: this._EmpCode
            });
          }
          
          if (newQuarterValue !== this.teamOriginalValues[newQuarterKey]) {
            updatedTargets.push({
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: '',
              SaleTargetQuarter: quarterMap[i],
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'QUARTER',
              SaleTargetAmount: newQuarterValue,
              SaleTargetFlagNewCust: 'Y',
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        // Process yearly data
        const oldYearKey = `${teamKey}_old_year`;
        const newYearKey = `${teamKey}_new_year`;
        
        const oldYearValue = this.teamEditedValues[oldYearKey];
        const newYearValue = this.teamEditedValues[newYearKey];
        
        // Only add to update list if value has changed
        if (oldYearValue !== this.teamOriginalValues[oldYearKey]) {
          updatedTargets.push({
            SaleTargetTeamCode: team.teamCode,
            SaleTargetTeamName: team.teamName,
            SaleTargetEmpCode: '',
            SaleTargetEmpName: '',
            SaleTargetMonth: '',
            SaleTargetQuarter: '',
            SaleTargetYear: this.yearSearch,
            SaleTargetPeriod: 'YEAR',
            SaleTargetAmount: oldYearValue,
            SaleTargetFlagNewCust: 'N',
            RequesterEmpCode: this._EmpCode
          });
        }
        
        if (newYearValue !== this.teamOriginalValues[newYearKey]) {
          updatedTargets.push({
            SaleTargetTeamCode: team.teamCode,
            SaleTargetTeamName: team.teamName,
            SaleTargetEmpCode: '',
            SaleTargetEmpName: '',
            SaleTargetMonth: '',
            SaleTargetQuarter: '',
            SaleTargetYear: this.yearSearch,
            SaleTargetPeriod: 'YEAR',
            SaleTargetAmount: newYearValue,
            SaleTargetFlagNewCust: 'Y',
            RequesterEmpCode: this._EmpCode
          });
        }
      });
      
      if (updatedTargets.length === 0) {
        alert('No changes detected');
        this.teamTableEditMode = false;
        return;
      }
      
      // Send update request
      const requestData = { targets: updatedTargets };
      const strjson = JSON.stringify(requestData);
      
      this.httpClient.post(this.baseurl + "SaleTarget/SetSaleTargetBatch", strjson, httpOptions)
        .toPromise().then(() => {
          alert('Sale targets updated successfully');
          this.teamTableEditMode = false;
          this.LoadSaleTarget(true); // Refresh data
        }).catch(error => {
          console.error('Error updating sale targets:', error);
          alert('Failed to update sale targets');
        });
      
    } catch (error) {
      console.error('Error saving team table edits:', error);
      alert('Failed to save changes');
    }
  }
  
  async saveTableEdit() {
    try {
      // Get the active tab index
      const tabElements = document.querySelectorAll('mat-tab-body.mat-tab-body-active');
      const isTeamTab = tabElements.length > 0 && tabElements[0].getAttribute('id')?.includes('mat-tab-content-0-1');

      console.log('isTeamTab', tabElements);
      
      if (isTeamTab) {
        // If we're in the team tab, use the saveTeamTableEdit function
        await this.saveTeamTableEdit();
        return;
      }
      
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        alert('Failed to get authentication token');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      
      // Prepare the data to save
      const updatedTargets = [];
      
      // Process employee data
      this.processedTeamData.forEach(team => {
        team.employees.forEach(emp => {
          // Create composite key with employee code and team code
          const compositeKey = `${emp.empCode}_${emp.teamCode}`;
          
          // Process old customer data
          for (let i = 0; i < 12; i++) {
            const oldMonthKey = `${compositeKey}_old_month_${i}`;
            if (this.editedValues[oldMonthKey] !== this.originalValues[oldMonthKey]) {
              updatedTargets.push({
                SaleTargetId: 0,
                SaleTargetTeamCode: emp.teamCode,
                SaleTargetTeamName: emp.teamName,
                SaleTargetEmpCode: emp.empCode,
                SaleTargetEmpName: emp.empName,
                SaleTargetMonth: (i + 1).toString(),
                SaleTargetQuarter: '',
                SaleTargetYear: this.yearSearch,
                SaleTargetPeriod: 'MONTH',
                SaleTargetAmount: this.editedValues[oldMonthKey],
                SaleTargetFlagNewCust: 'N',
                CreateBy: this._EmpCode,
                RequesterEmpCode: this._EmpCode
              });
            }
          }
          
          for (let i = 0; i < 4; i++) {
            const oldQuarterKey = `${compositeKey}_old_quarter_${i}`;
            if (this.editedValues[oldQuarterKey] !== this.originalValues[oldQuarterKey]) {
              updatedTargets.push({
                SaleTargetId: 0,
                SaleTargetTeamCode: emp.teamCode,
                SaleTargetTeamName: emp.teamName,
                SaleTargetEmpCode: emp.empCode,
                SaleTargetEmpName: emp.empName,
                SaleTargetMonth: '',
                SaleTargetQuarter: `Q${i + 1}`,
                SaleTargetYear: this.yearSearch,
                SaleTargetPeriod: 'QUARTER',
                SaleTargetAmount: this.editedValues[oldQuarterKey],
                SaleTargetFlagNewCust: 'N',
                CreateBy: this._EmpCode,
                RequesterEmpCode: this._EmpCode
              });
            }
          }
          
          const oldYearKey = `${compositeKey}_old_year`;
          if (this.editedValues[oldYearKey] !== this.originalValues[oldYearKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: emp.teamCode,
              SaleTargetTeamName: emp.teamName,
              SaleTargetEmpCode: emp.empCode,
              SaleTargetEmpName: emp.empName,
              SaleTargetMonth: '',
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'YEAR',
              SaleTargetAmount: this.editedValues[oldYearKey],
              SaleTargetFlagNewCust: 'N',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
          
          // Process new customer data
          for (let i = 0; i < 12; i++) {
            const newMonthKey = `${compositeKey}_new_month_${i}`;
            if (this.editedValues[newMonthKey] !== this.originalValues[newMonthKey]) {
              updatedTargets.push({
                SaleTargetId: 0,
                SaleTargetTeamCode: emp.teamCode,
                SaleTargetTeamName: emp.teamName,
                SaleTargetEmpCode: emp.empCode,
                SaleTargetEmpName: emp.empName,
                SaleTargetMonth: (i + 1).toString(),
                SaleTargetQuarter: '',
                SaleTargetYear: this.yearSearch,
                SaleTargetPeriod: 'MONTH',
                SaleTargetAmount: this.editedValues[newMonthKey],
                SaleTargetFlagNewCust: 'Y',
                CreateBy: this._EmpCode,
                RequesterEmpCode: this._EmpCode
              });
            }
          }
          
          for (let i = 0; i < 4; i++) {
            const newQuarterKey = `${compositeKey}_new_quarter_${i}`;
            if (this.editedValues[newQuarterKey] !== this.originalValues[newQuarterKey]) {
              updatedTargets.push({
                SaleTargetId: 0,
                SaleTargetTeamCode: emp.teamCode,
                SaleTargetTeamName: emp.teamName,
                SaleTargetEmpCode: emp.empCode,
                SaleTargetEmpName: emp.empName,
                SaleTargetMonth: '',
                SaleTargetQuarter: `Q${i + 1}`,
                SaleTargetYear: this.yearSearch,
                SaleTargetPeriod: 'QUARTER',
                SaleTargetAmount: this.editedValues[newQuarterKey],
                SaleTargetFlagNewCust: 'Y',
                CreateBy: this._EmpCode,
                RequesterEmpCode: this._EmpCode
              });
            }
          }
          
          const newYearKey = `${compositeKey}_new_year`;
          if (this.editedValues[newYearKey] !== this.originalValues[newYearKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: emp.teamCode,
              SaleTargetTeamName: emp.teamName,
              SaleTargetEmpCode: emp.empCode,
              SaleTargetEmpName: emp.empName,
              SaleTargetMonth: '',
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'YEAR',
              SaleTargetAmount: this.editedValues[newYearKey],
              SaleTargetFlagNewCust: 'Y',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
        });
      });
      
      // Process team-only data
      this.processedTeamOnlyData.forEach(team => {
        // Process old customer data
        for (let i = 0; i < 12; i++) {
          const oldMonthKey = `${team.teamCode}_team_old_month_${i}`;
          if (this.editedValues[oldMonthKey] !== this.originalValues[oldMonthKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: (i + 1).toString(),
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'MONTH',
              SaleTargetAmount: this.editedValues[oldMonthKey],
              SaleTargetFlagNewCust: 'N',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        for (let i = 0; i < 4; i++) {
          const oldQuarterKey = `${team.teamCode}_team_old_quarter_${i}`;
          if (this.editedValues[oldQuarterKey] !== this.originalValues[oldQuarterKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: '',
              SaleTargetQuarter: `Q${i + 1}`,
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'QUARTER',
              SaleTargetAmount: this.editedValues[oldQuarterKey],
              SaleTargetFlagNewCust: 'N',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        const oldYearKey = `${team.teamCode}_team_old_year`;
        if (this.editedValues[oldYearKey] !== this.originalValues[oldYearKey]) {
          updatedTargets.push({
            SaleTargetId: 0,
            SaleTargetTeamCode: team.teamCode,
            SaleTargetTeamName: team.teamName,
            SaleTargetEmpCode: '',
            SaleTargetEmpName: '',
            SaleTargetMonth: '',
            SaleTargetQuarter: '',
            SaleTargetYear: this.yearSearch,
            SaleTargetPeriod: 'YEAR',
            SaleTargetAmount: this.editedValues[oldYearKey],
            SaleTargetFlagNewCust: 'N',
            CreateBy: this._EmpCode,
            RequesterEmpCode: this._EmpCode
          });
        }
        
        // Process new customer data
        for (let i = 0; i < 12; i++) {
          const newMonthKey = `${team.teamCode}_team_new_month_${i}`;
          if (this.editedValues[newMonthKey] !== this.originalValues[newMonthKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: (i + 1).toString(),
              SaleTargetQuarter: '',
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'MONTH',
              SaleTargetAmount: this.editedValues[newMonthKey],
              SaleTargetFlagNewCust: 'Y',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        for (let i = 0; i < 4; i++) {
          const newQuarterKey = `${team.teamCode}_team_new_quarter_${i}`;
          if (this.editedValues[newQuarterKey] !== this.originalValues[newQuarterKey]) {
            updatedTargets.push({
              SaleTargetId: 0,
              SaleTargetTeamCode: team.teamCode,
              SaleTargetTeamName: team.teamName,
              SaleTargetEmpCode: '',
              SaleTargetEmpName: '',
              SaleTargetMonth: '',
              SaleTargetQuarter: `Q${i + 1}`,
              SaleTargetYear: this.yearSearch,
              SaleTargetPeriod: 'QUARTER',
              SaleTargetAmount: this.editedValues[newQuarterKey],
              SaleTargetFlagNewCust: 'Y',
              CreateBy: this._EmpCode,
              RequesterEmpCode: this._EmpCode
            });
          }
        }
        
        const newYearKey = `${team.teamCode}_team_new_year`;
        if (this.editedValues[newYearKey] !== this.originalValues[newYearKey]) {
          updatedTargets.push({
            SaleTargetId: 0,
            SaleTargetTeamCode: team.teamCode,
            SaleTargetTeamName: team.teamName,
            SaleTargetEmpCode: '',
            SaleTargetEmpName: '',
            SaleTargetMonth: '',
            SaleTargetQuarter: '',
            SaleTargetYear: this.yearSearch,
            SaleTargetPeriod: 'YEAR',
            SaleTargetAmount: this.editedValues[newYearKey],
            SaleTargetFlagNewCust: 'Y',
            CreateBy: this._EmpCode,
            RequesterEmpCode: this._EmpCode
          });
        }
      });
      
      // If there are no changes, just exit edit mode
      if (updatedTargets.length === 0) {
        alert('No changes detected');
        this.tableEditMode = false;
        return;
      }
      
      // Send the updated targets to the server
      const payload = {
        targets: updatedTargets
      };
      
      const strjson = JSON.stringify(payload);
      
      await this.httpClient.post(this.baseurl + "SaleTarget/SetSaleTargetBatch", strjson, httpOptions)
        .toPromise();
      
      alert('Sales targets updated successfully');
      this.tableEditMode = false;
      this.LoadSaleTarget(true);
    } catch (error) {
      console.error('Error saving sale targets:', error);
      alert('Failed to save sale targets');
    }
  }

  async LoadSaleTargetByAsset(search: boolean = false) {
    if(!search){
        this.SaleTargetByAssetList = [];
        this.txtSearchSaleTeam = null;
        this.txtSearchSaleTeamMember = null;
        this.yearSearch = null;
        this.resetSearch();
        return;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        var objectjson = {};
        objectjson['RequesterEmpCode'] = this.checkUndefinedString(this._EmpCode);
        objectjson['SaleTargetTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
        objectjson['SaleTargetEmpCode'] = this.checkUndefinedString(this.txtSearchSaleTeamMember);
        objectjson['SaleTargetMonth'] = this.checkUndefinedString(this.monthSearch);
        objectjson['SaleTargetQuarter'] = this.checkUndefinedString(this.quarterSearch);
        objectjson['SaleTargetYear'] = this.checkUndefinedString(this.yearSearch);
        
        let strjson = JSON.stringify(objectjson);

        try {
            // ✅ เปลี่ยนจาก .then()/.catch() มาใช้ await ตรงนี้
            const data = await this.httpClient.post<SaleTargetByAssetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetByAssetList", strjson, httpOptions).toPromise();
            
            this.SaleTargetByAssetList = data;
            //console.log('res data GetSaleTargetByAssetList (after save): ', data); // เปิด console.log นี้เพื่อตรวจสอบข้อมูลหลังโหลดใหม่
            
            this.totalItems = data.length;
            if(this.SaleTargetByAssetList.length <= 0){
                this.currentPageNumber = 0;
            }else{
                if(this.currentPageNumber == 0) this.currentPageNumber = 1;
                this.totalItems = Number(this.SaleTargetByAssetList[0].itemTotal);
            }
            this.totalPages = Math.ceil(this.totalItems / this.environment);
            
            // ✅ เรียก processDataForTableAssetType() หลังจากข้อมูลถูกดึงมาและถูกกำหนดให้กับ SaleTargetByAssetList แล้ว
            this.processDataForTableAssetType();
            
            // ✅ และอย่าลืมเรียก initializeOriginalAssetValues() ด้วย (ถ้ามี)
            // เพื่อให้ค่าสำหรับการแก้ไขครั้งต่อไปเป็นข้อมูลล่าสุด
            this.initializeAssetTypeEditValues(); // หากยังไม่มีฟังก์ชันนี้ ให้เพิ่มตามที่แนะนำไปก่อนหน้า

        } catch (error) {
            console.error('Error loading sale targets:', error);
            // แสดงข้อความผิดพลาดให้ผู้ใช้ทราบ
            alert('Failed to load updated sales target data.');
            // ✅ สำคัญ: ต้อง throw error กลับไป เพื่อให้ฟังก์ชันที่เรียก LoadSaleTargetByAsset
            // (เช่น saveTableAssetTypeEdit) สามารถจับ error ได้ด้วย catch ของมันเอง
            throw error; 
        }
    }
}

  processDataForTableAssetType() {
    const groupedData: any[] = [];
    const teamMap = new Map<string, any>();
    const createEmptyValues = () => Array(17).fill(0); // สร้างอาร์เรย์ 17 ช่อง สำหรับ 12 เดือน, 4 ไตรมาส, 1 ปีรวม

    //console.log('--- Starting processDataForTableAssetType ---');
    //console.log('1. Initial SaleTargetByAssetList (จาก Backend):', this.SaleTargetByAssetList);
    //console.log('2. SaleTargetByAssetList.length:', this.SaleTargetByAssetList ? this.SaleTargetByAssetList.length : 'null/undefined');

    const orderedPeriods = [
      { type: 'Month', value: '1' }, { type: 'Month', value: '2' }, { type: 'Month', value: '3' },
      { type: 'Month', value: '4' }, { type: 'Month', value: '5' }, { type: 'Month', value: '6' },
      { type: 'Month', value: '7' }, { type: 'Month', value: '8' }, { type: 'Month', value: '9' },
      { type: 'Month', value: '10' }, { type: 'Month', value: '11' }, { type: 'Month', value: '12' },
      { type: 'Quarter', value: 'Q1' }, { type: 'Quarter', value: 'Q2' },
      { type: 'Quarter', value: 'Q3' }, { type: 'Quarter', value: 'Q4' },
      { type: 'Year', value: 'Total' },
    ];

    const periodKeyToIndexMap = new Map<string, number>();
    orderedPeriods.forEach((p, idx) => {
      let key;
      if (p.type === 'Month') key = `Month_${p.value}`;
      else if (p.type === 'Quarter') key = `Quarter_${p.value}`;
      else if (p.type === 'Year') key = `Year_${p.value}`;
      periodKeyToIndexMap.set(key, idx);
    });

    // Pass 1: จัดกลุ่มข้อมูลและ Map ค่าจาก API
    let processedItemCount = 0;
    for (const item of this.SaleTargetByAssetList) {
      if (!item.SaleTargetEmpCode || !item.SaleTargetEmpName?.trim()) {
        //console.warn('Skipping item due to missing EmpCode or EmpName:', item);
        continue;
      }
      processedItemCount++;

      const teamKey = item.SaleTargetTeamCode;
      const empKey = item.SaleTargetEmpCode;
      const assetKey = item.SaleTargetAssetTypeCode;

      if (!teamMap.has(teamKey)) {
        const newTeam = { teamCode: teamKey, teamName: item.SaleTargetTeamName, employees: [] };
        teamMap.set(teamKey, newTeam);
        groupedData.push(newTeam);
      }
      const team = teamMap.get(teamKey);

      let employee = team.employees.find(e => e.empCode === empKey);
      if (!employee) {
        employee = { empCode: empKey, empName: item.SaleTargetEmpName, assetTypes: [] };
        team.employees.push(employee);
      }

      let assetType = employee.assetTypes.find(a => a.assetTypeCode === assetKey);
      if (!assetType) {
        assetType = {
          assetTypeCode: assetKey,
          assetTypeName: item.SaleTargetAssetTypeName,
          values: createEmptyValues(),
          flagAutoSum: item.FlagAutoSum
        };
        employee.assetTypes.push(assetType);
      }

      let periodKey: string | undefined;
      // ตรวจสอบว่ารายการนี้เป็นยอดรวมไตรมาสหรือปีที่มาจาก Backend (SaleTargetAmount อาจเป็น 0)
      const isQuarterlySumFromBackend = item.SaleTargetQuarter && !item.SaleTargetMonth;
      const isYearlySumFromBackend = item.SaleTargetYear && !item.SaleTargetMonth && !item.SaleTargetQuarter;

      // Map ค่าจาก Backend เข้าไปใน assetType.values
      // สำหรับค่าไตรมาสและปี ถ้า Backend ส่งค่ามา (ไม่เป็น null) ให้ใช้ค่าจาก Backend ก่อน
      if (item.SaleTargetMonth) {
        periodKey = `Month_${item.SaleTargetMonth}`;
      } else if (isQuarterlySumFromBackend) { // Backend ระบุไตรมาสมา (แม้ค่าจะเป็น 0)
        periodKey = `Quarter_${item.SaleTargetQuarter}`;
      } else if (isYearlySumFromBackend) { // Backend ระบุปีมา (แม้ค่าจะเป็น 0)
        periodKey = `Year_Total`;
      }

      if (periodKey) {
        const targetIndex = periodKeyToIndexMap.get(periodKey);
        if (targetIndex !== undefined) {
          assetType.values[targetIndex] = item.SaleTargetAmount; // Map ค่าจาก Backend
          //console.log(`PASS 1: Mapped raw value for Asset ${assetKey}, Period Key '${periodKey}', Index ${targetIndex}: ${item.SaleTargetAmount}.`);
        } else {
          //console.warn(`Mapping for periodKey "${periodKey}" not found in map. Item:`, item);
        }
      } else {
        //console.warn(`Could not determine period type for item:`, item);
      }
    }

    //console.log(`\n--- Pass 1 completed. Total items processed: ${processedItemCount} ---`);
    //console.log('3. GroupedData after Pass 1 (raw API values mapped):', groupedData);

    // --- Pass 2: คำนวณ AutoSums (Quarterly และ Yearly) เฉพาะเมื่อไม่มีค่า หรือเป็น 0 จาก Backend ---
    //console.log('\n--- Pass 2: Calculating AutoSums in Frontend (Conditional) ---');
    for (const team of groupedData) {
      for (const emp of team.employees) {
        for (const asset of emp.assetTypes) {
          //console.log(`Calculating AutoSum for Emp: ${emp.empCode}, Asset: ${asset.assetTypeCode}`);

          const v = asset.values;
          const sumFn = (arr: number[]) => arr.reduce((a, b) => (a || 0) + (b || 0), 0); // ฟังก์ชันช่วย Sum ค่า

          // *** AutoSum สำหรับไตรมาส ***
          const quartersConfig = [
            { index: 12, months: [0, 1, 2], name: 'Q1' },  // Jan, Feb, Mar
            { index: 13, months: [3, 4, 5], name: 'Q2' },  // Apr, May, Jun
            { index: 14, months: [6, 7, 8], name: 'Q3' },  // Jul, Aug, Sep
            { index: 15, months: [9, 10, 11], name: 'Q4' } // Oct, Nov, Dec
          ];

          quartersConfig.forEach(q => {
            // ตรวจสอบว่าค่าของไตรมาสนั้นๆ ใน `asset.values` เป็น null หรือ 0 หรือไม่
            // ถ้าเป็น null หรือ 0 หรือไม่ได้ถูก Map มาจาก Backend (undefined) ให้คำนวณใหม่
            if (v[q.index] === null || v[q.index] === 0 || v[q.index] === undefined) {
              const monthlyValuesForQuarter = q.months.map(mIndex => v[mIndex]);
              const calculatedSum = sumFn(monthlyValuesForQuarter);
              if (calculatedSum > 0) { // หากคำนวณได้ค่ามากกว่า 0
                v[q.index] = calculatedSum;
                //console.log(`AutoSummed ${q.name} (Index ${q.index}) for Asset ${asset.assetTypeCode} = ${calculatedSum}`);
              } else {
                v[q.index] = 0; // หาก sum ได้ 0 ก็ตั้งค่าเป็น 0
              }
            } else {
              //console.log(`    Skipping AutoSum for ${q.name} (Index ${q.index}) for Asset ${asset.assetTypeCode}. Value already exists: ${v[q.index]}`);
            }
          });


          // *** AutoSum สำหรับยอดรวมปี ***
          // ยอดรวมปี (Index 16) จะคำนวณจากยอดรวมของ Q1, Q2, Q3, Q4
          // เช่นกัน ถ้าค่าใน v[16] เป็น null หรือ 0 หรือ undefined ให้คำนวณใหม่
          if (v[16] === null || v[16] === 0 || v[16] === undefined) {
            const quarterlyValuesForYear = [v[12], v[13], v[14], v[15]];
            const calculatedYearSum = sumFn(quarterlyValuesForYear);
            if (calculatedYearSum > 0) { // หากคำนวณได้ค่ามากกว่า 0
              v[16] = calculatedYearSum;
              //console.log(`AutoSummed Year Total (Index 16) for Asset ${asset.assetTypeCode} = ${calculatedYearSum}`);
            } else {
              v[16] = 0; // หาก sum ได้ 0 ก็ตั้งค่าเป็น 0
            }
          } else {
            //console.log(`Skipping AutoSum for Year Total (Index 16) for Asset ${asset.assetTypeCode}. Value already exists: ${v[16]}`);
          }

          //console.log(`AutoSum completed for Emp: ${emp.empCode}, Asset: ${asset.assetTypeCode}. Final values array:`, [...v]);
        }
      }
    }
    //console.log('--- Pass 2 completed. Conditional sums calculated by Frontend. ---');

    this.processedAssetTypeData = groupedData;
    //console.log('\n--- processDataForTableAssetType completed. Final this.processedAssetTypeData: ---');
    //console.log(this.processedAssetTypeData);

     this.processedAssetTypeTeamData = this.processedAssetTypeData.map(team => ({
    teamCode: team.teamCode,
    teamName: team.teamName,
    employees: team.employees.map(emp => ({
      empCode: emp.empCode,
      empName: emp.empName,
      teamCode: team.teamCode,
      teamName: team.teamName,
      assetTypes: emp.assetTypes
    }))
  }));

  //console.log('✅ processedAssetTypeTeamData:', this.processedAssetTypeTeamData);

    if (this.processedAssetTypeData.length === 0) {
      //console.warn('WARNING: Final processedAssetTypeData is empty. Table might not render data rows.');
    } else {
      //console.log('SUCCESS: Final processedAssetTypeData has data. Table should display calculated sums correctly.');
    }
  }

  cancelTableAssetTypeEdit() {
    this.tableAssetTypeEditMode = false;
    this.editedAssetTypeValues = {};
    this.originalAssetTypeValues = {};
  }

  toggleTableAssetTypeEditMode() {
    
      // Member tab
      //if (!this.tableEditMode) {
      //  this.tableEditMode = true;
      //  this.initializeEditValues();
      //} else {
      //  this.cancelTableEdit();
      //}
    

      if (!this.tableAssetTypeEditMode) {
        this.tableAssetTypeEditMode = true;
        this.initializeAssetTypeEditValues();
      } else {
        this.cancelTableAssetTypeEdit();
      }
  }



  initializeAssetTypeEditValues() {
  this.editedAssetTypeValues = {};
  this.originalAssetTypeValues = {};

  if (!this.processedAssetTypeTeamData || this.processedAssetTypeTeamData.length === 0) {
    console.warn('processedAssetTypeTeamData is empty, nothing to initialize.');
    return;
  }

  this.processedAssetTypeTeamData.forEach(team => {
    team.employees.forEach(emp => {
      emp.assetTypes.forEach(asset => {
        for (let i = 0; i < 17; i++) {
          const key = `${emp.empCode}_${team.teamCode}_${asset.assetTypeCode}_value_${i}`;
          const value = asset.values[i] ?? 0;
          this.editedAssetTypeValues[key] = value;
          this.originalAssetTypeValues[key] = value;
        }
      });
    });
  });

  //console.log('✅ initializeAssetTypeEditValues complete:', { editedAssetTypeValues: this.editedAssetTypeValues, originalAssetTypeValues: this.originalAssetTypeValues});
}

async saveTableAssetTypeEdit() {
  try {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      alert('Failed to get authentication token');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const updatedTargets: any[] = [];

    // ✅ ใช้ processedAssetTypeTeamData
    this.processedAssetTypeTeamData.forEach(team => {
      team.employees.forEach(emp => {
        emp.assetTypes.forEach(asset => {
          for (let i = 0; i < 17; i++) {
            const key = `${emp.empCode}_${team.teamCode}_${asset.assetTypeCode}_value_${i}`;
            const edited = this.editedAssetTypeValues[key];
            const original = this.originalAssetTypeValues[key];

            if (edited !== original) {
              const payload: any = {
                SaleTargetByAssetId: 0,
                SaleTargetTeamCode: team.teamCode,
                SaleTargetTeamName: team.teamName,
                SaleTargetEmpCode: emp.empCode,
                SaleTargetEmpName: emp.empName,
                SaleTargetAssetTypeCode: asset.assetTypeCode,
                SaleTargetAssetTypeName: asset.assetTypeName,
                SaleTargetAmount: edited,
                SaleTargetYear: this.yearSearch,
                CreateBy: this._EmpCode,
                RequesterEmpCode: this._EmpCode
              };

              if (i < 12) {
                payload.SaleTargetPeriod = 'MONTH';
                payload.SaleTargetMonth = (i + 1).toString();
                payload.SaleTargetQuarter = '';
              } else if (i >= 12 && i <= 15) {
                payload.SaleTargetPeriod = 'QUARTER';
                payload.SaleTargetMonth = '';
                payload.SaleTargetQuarter = `Q${i - 11}`;
              } else if (i === 16) {
                payload.SaleTargetPeriod = 'YEAR';
                payload.SaleTargetMonth = '';
                payload.SaleTargetQuarter = '';
              }

              updatedTargets.push(payload);
            }
          }
        });
      });
    });

    if (updatedTargets.length === 0) {
      alert('No changes detected');
      this.tableAssetTypeEditMode = false;
      return;
    }

    //const strjson = JSON.stringify({ targets: updatedTargets });
    const strjson = JSON.stringify(updatedTargets); // ส่งเป็น Array

    console.log('Updated strjson to be sent:', strjson);

    await this.httpClient.post(this.baseurl + 'SaleTarget/SetSaleTargetByAssetType', strjson, httpOptions).toPromise();

    alert('Sales targets by asset type updated successfully');
    this.tableAssetTypeEditMode = false;
    await this.LoadSaleTargetByAsset(true);

  } catch (error) {
    console.error('Error saving sale targets by asset type:', error);
    alert('Failed to save sale targets by asset type');
    }
  }

async LoadAssetList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {
        LookupType: this.checkUndefinedString("ASSETLEVEL")
      };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions).toPromise();
            this.AssetList = data;

            if (this.AssetList.length > 0) {
              //this.ddlAsset = this.AssetList[0].LookupCode
            }

            //console.log('load AssetList:', this.AssetList);
        } catch (error) {
            console.error('loadAssetList: Error:', error);
            this.AssetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadAssetList: Token ไม่พร้อมใช้งาน');
    }
  }

async LoadAssetGroupMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {};

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/GetAssetGroup", strjson, httpOptions).toPromise();
            this.AssetGroupMasterList = data;

            console.log('load AssetGroupMasterList:', this.AssetGroupMasterList);
        } catch (error) {
            console.error('loadAssetGroupMasterList: Error:', error);
            this.AssetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadAssetGroupMasterList: Token ไม่พร้อมใช้งาน');
    }
  }

async LoadAssetCategoryMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {};

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/GetAssetCategory", strjson, httpOptions).toPromise();
            this.AssetCategoryMasterList = data;

            console.log('load AssetCategoryMasterList:', this.AssetCategoryMasterList);
        } catch (error) {
            console.error('AssetCategoryMasterList: Error:', error);
            this.AssetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('AssetCategoryMasterList: Token ไม่พร้อมใช้งาน');
    }
  } // AssetTypeMasterList

async LoadAssetTypeMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {};

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/GetAssetType", strjson, httpOptions).toPromise();
            this.AssetTypeMasterList = data;

            console.log('load AssetTypeMasterList:', this.AssetTypeMasterList);
        } catch (error) {
            console.error('AssetTypeMasterList: Error:', error);
            this.AssetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('AssetTypeMasterList: Token ไม่พร้อมใช้งาน');
    }
  }

async LoadSaleTargetAssetCategoryList() {
  var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {
          SaleTargetTeamCode: this.checkUndefinedString(this.txtSearchSaleTeam),
          SaleTargetYear: this.checkUndefinedString(this.yearSearch)
        };

        //console.log('loadTeamTarget: objectjson ที่จะส่ง:', objectjson);

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<SaleTargetByAssetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetByAssetCategory", strjson, httpOptions).toPromise();
            this.SaleTargetAssetCategoryList = data;

            if (this.ddlAsset === 'AC') {
              this.onChangeddlAsset('AC'); // อัปเดตจาก SaleTargetAssetCategoryList ใหม่
      }

            console.log('load SaleTargetAssetCategoryList:', this.SaleTargetAssetCategoryList);
        } catch (error) {
            console.error('SaleTargetAssetCategoryList: Error:', error);
            this.AssetList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('SaleTargetAssetCategoryList: Token ไม่พร้อมใช้งาน');
    }
  }

onChangeddlAsset(event: any): void {
  const value = typeof event === 'string' ? event : event?.target?.value;
  this.ddlAsset = value;

  // Set master list & field name
  if (value === "AG") {
    this.currentAssetMasterList = this.AssetGroupMasterList;
    this.currentAssetCodeField = 'AssetGroupCode';
    this.currentAssetNameField = 'AssetGroupName';
  } else if (value === "AC") {
    this.currentAssetMasterList = this.AssetCategoryMasterList;
    this.currentAssetCodeField = 'AssetCategoryCode';
    this.currentAssetNameField = 'AssetCategoryName';
  } else if (value === "AS") {
    this.currentAssetMasterList = this.AssetTypeMasterList;
    this.currentAssetCodeField = 'AssetTypeCode';
    this.currentAssetNameField = 'AssetTypeName';
  }

  // Load & Map Data
  const fieldToMatch = 'SaleTarget' + this.ddlAssetFieldPrefix() + 'Code'; // eg. SaleTargetAssetCategoryCode
  this.editedAssetMonthly = {};

  for (const item of this.currentAssetMasterList) {
    const code = item[this.currentAssetCodeField];
    for (let month = 1; month <= 12; month++) {
      const key = `${code}_month_${month}`;
      const match = this.SaleTargetAssetCategoryList.find(r =>
        r[fieldToMatch] === code && Number(r.SaleTargetMonth) === month
      );
      this.editedAssetMonthly[key] = match?.SaleTargetAmount || 0;
    }
  }

  this.originalAssetMonthly = { ...this.editedAssetMonthly };
  this.SumYearAmount = Object.values(this.editedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
  }

// Helper Function
ddlAssetFieldPrefix(): string {
  if (this.ddlAsset === 'AG') return 'AssetGroup';
  if (this.ddlAsset === 'AC') return 'AssetCategory';
  if (this.ddlAsset === 'AS') return 'AssetType';
  return '';
  }

toggleAssetEditMode() {
  this.assetEditMode = !this.assetEditMode;
  if (this.assetEditMode) {
    // เมื่อเข้าสู่โหมดแก้ไข ให้โคลนค่าปัจจุบันของ editedAssetMonthly เก็บไว้
    // นี่คือ "ค่าก่อนหน้า" ที่จะใช้สำหรับปุ่ม Cancel
    this.originalAssetMonthly = { ...this.editedAssetMonthly };
    this.draftEditedAssetMonthly = { ...this.editedAssetMonthly };
  } else {
    this.cancelAssetEdit();
  }

  }

cancelAssetEdit() {
  // กู้คืนค่า editedAssetMonthly กลับไปเป็น originalAssetMonthly
  this.editedAssetMonthly = { ...this.originalAssetMonthly };
  // ออกจากโหมดแก้ไข
  this.draftEditedAssetMonthly = { ...this.originalAssetMonthly };
  this.assetEditMode = false;
  // (ถ้าต้องการ) สามารถเคลียร์ค่าใน categoryBudgetInput ได้เช่นกัน
  this.SumYearAmount = Object.values(this.editedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
  this.categoryBudgetInput = {};
  }

async saveAssetEdit(): Promise<void> {
  const year = this.yearSearch;
  const teamCode = this.txtSearchSaleTeam;
  const changedRecords: any[] = [];

  // for (const key in this.editedAssetMonthly) {
  //   const original = this.originalAssetMonthly[key] || 0;
  //   const current = this.editedAssetMonthly[key] || 0;
  for (const key in this.draftEditedAssetMonthly) {
    const original = this.originalAssetMonthly[key] || 0;
    const current = this.draftEditedAssetMonthly[key] || 0;

    if (original !== current) {
      const [code, , month] = key.split('_');

      const record: any = {
        SaleTargetYear: year,
        SaleTargetTeamCode: teamCode,
        SaleTargetMonth: Number(month),
        SaleTargetAmount: current,
        SaleTargetAssetCategoryCode: code,
        CreateBy: this._EmpCode,
        UpdateBy: this._EmpCode
      };

      // ป้อน key ให้ตรงกับระดับที่เลือก
      if (this.ddlAsset === 'AG') {
        record.SaleTargetAssetGroupCode = code;
      } else if (this.ddlAsset === 'AC') {
        record.SaleTargetAssetLevel = 'AC';
        record.SaleTargetAssetCategoryCode = code;
        record.SaleTargetAssetGroupCode = null;
        record.SaleTargetAssetTypeCode = null; 
      } else if (this.ddlAsset === 'AS') {
        record.SaleTargetAssetTypeCode = code;
      }

      changedRecords.push(record);
    }
  }

  console.log('Saving only changed:', changedRecords);

  if (changedRecords.length === 0) {
      console.log('No changes to save. Exiting edit mode.');
      this.assetEditMode = false;
      this.categoryBudgetInput = {};
      return;
    }

    try {
      // 1. Refresh Token ก่อนเรียก API เพื่อให้มั่นใจว่า Token ยังไม่หมดอายุ
      var auth_token = await this.TokenService.RefreshToken();

      if (!!auth_token) { // ถ้าได้ Token มา
        console.log('Authentication token obtained. Proceeding with API call.');

        // 2. กำหนด HTTP Headers พร้อม Authorization Token
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        // 3. เรียกใช้ HTTP POST เพื่อส่ง Array ของ changedRecords ไปยัง Backend API
        this.httpClient.post<any>( // Endpoint คาดหวัง Object Response ทั่วไป
          this.baseurl + "SaleTarget/InsertUpdateSaleTargetByAssetCategory", // **ตรวจสอบ Path API Endpoint ของคุณให้ถูกต้อง**
          changedRecords, // **ส่ง Array ของ SaleTargetRecord ไปตรงๆ**
          httpOptions
        )
        .subscribe({
          // 4. จัดการ Response เมื่อ API สำเร็จ
          next: (response) => {
            console.log('Sale Target saved successfully:', response);
            // *** สิ่งสำคัญ: อัปเดต UI State หลังจาก Backend ตอบกลับว่าสำเร็จเท่านั้น ***
            this.editedAssetMonthly = { ...this.draftEditedAssetMonthly }; // คอมมิทค่าจาก draft ไป edited
            this.assetEditMode = false; // ออกจากโหมดแก้ไข
            this.originalAssetMonthly = { ...this.editedAssetMonthly }; // อัปเดต original เป็นค่าที่บันทึกแล้ว
            this.SumYearAmount = Object.values(this.editedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
            this.categoryBudgetInput = {}; // เคลียร์ Budget Input

            // แสดง Notification หรือ Modal แจ้งผู้ใช้ว่าบันทึกสำเร็จ
            // ตรวจสอบว่า #ModalCreateCompGroupComplete เป็น ID ของ Modal ที่คุณต้องการแสดง
            $('#ModalCreateCompGroupComplete').modal('show');
          },
          // 5. จัดการ Error เมื่อ API ล้มเหลว
          error: (error) => {
            console.error('Error saving Sale Target:', error);
            // *** สิ่งสำคัญ: ไม่ควรอัปเดต UI State หากบันทึกไม่สำเร็จ ***
            // เพื่อให้ผู้ใช้เห็นค่าที่กรอกไว้ และสามารถแก้ไขหรือลองใหม่ได้
            // แสดง Notification แจ้งผู้ใช้ว่าเกิดข้อผิดพลาด
            // ตัวอย่าง: this.notificationService.showError('บันทึกข้อมูลไม่สำเร็จ: ' + error.message);
          }
          // 6. (Optional) Complete Callback
          // complete: () => {
          //   console.log('API call completed.');
          // }
        });
      } else {
        console.error("Authentication token not available. Cannot proceed with save.");
        // แจ้งผู้ใช้ว่าไม่สามารถดำเนินการได้เพราะไม่มี Token
      }
    } catch (error) {
      console.error("An error occurred during token refresh or API call:", error);
      // จัดการข้อผิดพลาดที่อาจเกิดขึ้นก่อนที่ httpClient.post จะถูกเรียก (เช่น TokenService error)
    }

  // this.editedAssetMonthly = { ...this.draftEditedAssetMonthly };

  // this.assetEditMode = false;
  // this.originalAssetMonthly = { ...this.editedAssetMonthly };

  // this.SumYearAmount = Object.values(this.editedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
  // this.categoryBudgetInput = {};

  // TODO: ส่ง changedRecords ไปยัง backend API
  
  }

distributeBudget(assetCode: string): void { // เปลี่ยน categoryCode เป็น assetCode เพื่อให้สอดคล้องกับโครงสร้าง
  if (!this.assetEditMode) return; // อนุญาตให้กระจายงบประมาณเฉพาะในโหมดแก้ไขเท่านั้น

  const total = Number(this.categoryBudgetInput[assetCode] || 0); // ใช้ assetCode
  if (total <= 0) return;

  const base = Math.floor(total / 12);
  let remain = total - base * 12;

  // *** จุดที่แก้ไข ***
  // ไม่ต้องสร้าง Object ใหม่ทั้งหมด
  // ให้อัปเดตค่าบน Object this.editedAssetMonthly เดิมโดยตรง
  for (let i = 0; i < 12; i++) {
    const extra = remain > 0 ? 1 : 0;
    const distributed = base + extra;
    const key = `${assetCode}_month_${i + 1}`; // ใช้ assetCode

    // อัปเดตค่าโดยตรง
    //this.editedAssetMonthly[key] = distributed; // <--- แก้ไขตรงนี้
    this.draftEditedAssetMonthly[key] = distributed;
    if (extra > 0) remain--;
  }
  // หลังจากอัปเดตค่าทั้งหมดแล้ว ค่อยคำนวณ SumYearAmount ใหม่
  this.SumYearAmount = Object.values(this.draftEditedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
  //this.SumYearAmount = Object.values(this.editedAssetMonthly).reduce((acc: number, val: any) => acc + (+val || 0), 0);
  // *** สิ้นสุดจุดแก้ไข ***
  }   

  // Function to distribute a value evenly across months for old customers
  distributeOldCustomer(empCode: string, teamCode: string, amountStr: string) {
    const amount = parseFloat(amountStr);
    
    // Validate input
    if (isNaN(amount) || amount <= 0) {
      alert('Please enter a valid positive number');
      return;
    }
    
    // Calculate monthly distribution (divide by 12 and round to nearest integer)
    const monthlyAmount = Math.round(amount / 12);
    
    // Calculate remainder to ensure total equals the input amount
    let remainder = amount - (monthlyAmount * 12);
    
    // Create composite key with employee code and team code
    const compositeKey = `${empCode}_${teamCode}`;
    
    // Distribute to months
    for (let i = 0; i < 12; i++) {
      // Add remainder to the first month to ensure total equals input amount
      let adjustedAmount = monthlyAmount;
      if (i === 0 && remainder !== 0) {
        adjustedAmount += remainder;
      }
      
      const monthKey = `${compositeKey}_old_month_${i}`;
      this.editedValues[monthKey] = adjustedAmount;
    }
    
    // Calculate and update quarters
    for (let q = 0; q < 4; q++) {
      const quarterKey = `${compositeKey}_old_quarter_${q}`;
      const startMonth = q * 3;
      const quarterAmount = 
        this.editedValues[`${compositeKey}_old_month_${startMonth}`] +
        this.editedValues[`${compositeKey}_old_month_${startMonth + 1}`] +
        this.editedValues[`${compositeKey}_old_month_${startMonth + 2}`];
      
      this.editedValues[quarterKey] = quarterAmount;
    }
    
    // Update year total
    const yearKey = `${compositeKey}_old_year`;
    this.editedValues[yearKey] = amount;
  }
  
  // Function to distribute a value evenly across months for new customers
  distributeNewCustomer(empCode: string, teamCode: string, amountStr: string) {
    const amount = parseFloat(amountStr);
    
    // Validate input
    if (isNaN(amount) || amount <= 0) {
      alert('Please enter a valid positive number');
      return;
    }
    
    // Calculate monthly distribution (divide by 12 and round to nearest integer)
    const monthlyAmount = Math.round(amount / 12);
    
    // Calculate remainder to ensure total equals the input amount
    let remainder = amount - (monthlyAmount * 12);
    
    // Create composite key with employee code and team code
    const compositeKey = `${empCode}_${teamCode}`;
    
    // Distribute to months
    for (let i = 0; i < 12; i++) {
      // Add remainder to the first month to ensure total equals input amount
      let adjustedAmount = monthlyAmount;
      if (i === 0 && remainder !== 0) {
        adjustedAmount += remainder;
      }
      
      const monthKey = `${compositeKey}_new_month_${i}`;
      this.editedValues[monthKey] = adjustedAmount;
    }
    
    // Calculate and update quarters
    for (let q = 0; q < 4; q++) {
      const quarterKey = `${compositeKey}_new_quarter_${q}`;
      const startMonth = q * 3;
      const quarterAmount = 
        this.editedValues[`${compositeKey}_new_month_${startMonth}`] +
        this.editedValues[`${compositeKey}_new_month_${startMonth + 1}`] +
        this.editedValues[`${compositeKey}_new_month_${startMonth + 2}`];
      
      this.editedValues[quarterKey] = quarterAmount;
    }
    
    // Update year total
    const yearKey = `${compositeKey}_new_year`;
    this.editedValues[yearKey] = amount;
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      alert('Cannot use multiple files.');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      this.excelData = XLSX.utils.sheet_to_json(ws, { header: 1 });
      this.saveTableAssetTypeEditByUpload();
    };
    reader.readAsArrayBuffer(target.files[0]);
  }

  async saveTableAssetTypeEditByUpload() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        alert('Failed to get authentication token');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const updatedTargets: any[] = [];
      
      if (!this.excelData || this.excelData.length < 2) {
        alert('Invalid Excel file format or no data found.');
        return;
      }
      
      const headerRow = this.excelData[0] as string[];
    const cleanedHeaders = headerRow.map(header => (header ? header.trim().toLowerCase() : ''));
    
    const dataRows = this.excelData.slice(1);

    // หา Index ของ Header ที่จำเป็น (รหัส)
    const teamCodeIndex = cleanedHeaders.indexOf('saletargetteamcode');
    const empCodeIndex = cleanedHeaders.indexOf('saletargetempcode');
    const assetTypeCodeIndex = cleanedHeaders.indexOf('saletargetassettypecode');
    const yearIndex = cleanedHeaders.indexOf('saletargetyear');
    
    // หา Index ของ Header ที่เป็นชื่อ (ถ้ามี)
    const teamNameIndex = cleanedHeaders.indexOf('saletargetteamname');
    const empNameIndex = cleanedHeaders.indexOf('saletargetempname');
    const assetTypeNameIndex = cleanedHeaders.indexOf('saletargetassettypename');
    
    // ✅ เปลี่ยนเงื่อนไขการตรวจสอบ: ตรวจเฉพาะ Header ที่เป็น "รหัส" เท่านั้น
    if (teamCodeIndex === -1 || empCodeIndex === -1 || assetTypeCodeIndex === -1 || yearIndex === -1) {
      alert('Missing one of the required header columns: SaleTargetTeamCode, SaleTargetEmpCode, SaleTargetAssetTypeCode, SaleTargetYear.');
      return;
    }
      
      const monthColumns = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      
      // สร้าง Map ของข้อมูลตั้งต้นจาก processedAssetTypeData เพื่อใช้ในการเปรียบเทียบ
      const originalDataMap = new Map<string, number>();
      this.processedAssetTypeData.forEach(team => {
          team.employees.forEach(emp => {
              emp.assetTypes.forEach(asset => {
                  for (let i = 0; i < 12; i++) {
                      const key = `${emp.empCode}_${team.teamCode}_${asset.assetTypeCode}_${i}`;
                      originalDataMap.set(key, asset.values[i]);
                  }
              });
          });
      });

      for (const row of dataRows) {
          const teamCode = row[teamCodeIndex];
          const empCode = row[empCodeIndex];
          const assetTypeCode = row[assetTypeCodeIndex];
          const year = row[yearIndex];
          
          if (!teamCode || !empCode || !assetTypeCode || !year) {
              continue;
          }
          
          const teamName = row[teamNameIndex] || '';
          const empName = row[empNameIndex] || '';
          const assetTypeName = row[assetTypeNameIndex] || '';
          
          // วนลูปสำหรับแต่ละเดือน
          for (let i = 0; i < monthColumns.length; i++) {
              const monthColumnName = monthColumns[i];
              const monthIndex = headerRow.indexOf(monthColumnName);
              
              if (monthIndex > -1) {
                  const editedAmount = row[monthIndex];
                  
                  if (editedAmount === null || editedAmount === undefined || editedAmount === '') {
                      continue;
                  }
                  
                  const originalKey = `${empCode}_${teamCode}_${assetTypeCode}_${i}`;
                  const originalAmount = originalDataMap.get(originalKey) || 0;
                  
                  console.log('--- Checking input data before comparison ---');
                  console.log(`Key: ${originalKey}`);
                  console.log(`Excel Value (editedAmount): ${editedAmount}`);
                  console.log(`Original Value (originalAmount): ${originalAmount}`);
                  console.log('---------------------------------------------');
  
                  if (Number(editedAmount) !== Number(originalAmount)) {
                      const payload: any = {
                          SaleTargetByAssetId: 0,
                          SaleTargetTeamCode: teamCode,
                          SaleTargetTeamName: teamName,
                          SaleTargetEmpCode: empCode,
                          SaleTargetEmpName: empName,
                          SaleTargetAssetTypeCode: assetTypeCode,
                          SaleTargetAssetTypeName: assetTypeName,
                          SaleTargetAmount: editedAmount,
                          SaleTargetYear: year,
                          SaleTargetPeriod: 'MONTH',
                          SaleTargetMonth: (i + 1).toString(),
                          SaleTargetQuarter: '',
                          CreateBy: this._EmpCode,
                          RequesterEmpCode: this._EmpCode
                      };
                      updatedTargets.push(payload);
                  }
              }
          }
      }
      
      console.log('✅ Final JSON payload to be sent:', updatedTargets);
  
      if (updatedTargets.length === 0) {
        alert('No changes detected from the Excel file.');
        return;
      }
      
      const strjson = JSON.stringify(updatedTargets);
      
      await this.httpClient.post(this.baseurl + 'SaleTarget/SetSaleTargetByAssetType', strjson, httpOptions).toPromise();
  
      alert('Sales targets by asset type updated successfully from Excel file.');
      this.tableAssetTypeEditMode = false;
      await this.LoadSaleTargetByAsset(true);
      
    } catch (error) {
      console.error('Error saving sale targets from Excel:', error);
      alert('Failed to save sale targets from Excel file');
    }
  }

  private async generateSaleTargetExcelTemplate(): Promise<void> {
    const currentYear = new Date().getFullYear().toString(); // Use currentYear such as "2025"

    // 1. Get Master Lists (Asset Types และ Sale Team Employees)
    const assetTypes: AssetTypeInfo[] = this.AssetTypeMasterList;
    const saleTeamEmployees: SaleTeamEmployeeInfo[] = this.EmpMappingSaleTargetTeamList;

    // ตรวจสอบว่ามีข้อมูลเพียงพอที่จะสร้าง Excel หรือไม่
    if (assetTypes.length === 0 || saleTeamEmployees.length === 0) {
        console.warn('ไม่สามารถสร้าง Excel ได้: ข้อมูลประเภทสินทรัพย์หรือพนักงานว่างเปล่า');
        alert('ไม่สามารถสร้าง Excel ได้: ข้อมูลประเภทสินทรัพย์หรือพนักงานว่างเปล่า'); // แสดงแจ้งเตือน
        return;
    }

    // 2. กำหนด Headers สำหรับ Excel File (ต้องตรงกับโครงสร้างที่คุณต้องการ)
    const headers = [
        "SaleTargetYear", "SaleTargetTeamCode", "SaleTargetTeamName",
        "SaleTargetEmpCode", "SaleTargetEmpName", "SaleTargetAssetTypeCode",
        "SaleTargetAssetTypeName",
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const data: any[] = [];
    data.push(headers); // เพิ่ม Header Row เป็นแถวแรกของ Worksheet

    // 3. เรียงข้อมูลพนักงานตาม SaleTeamCode และ EmployeeCode
    // เพื่อให้การวนลูปสร้างแถวใน Excel ดูเป็นระเบียบและจัดกลุ่มได้ง่ายขึ้น
    saleTeamEmployees.sort((a, b) => {
        if (a.SaleTeamCode !== b.SaleTeamCode) {
        return a.SaleTeamCode.localeCompare(b.SaleTeamCode);
        }
        return a.EmployeeCode.localeCompare(b.EmployeeCode);
    });

    // 4. Grouping ข้อมูลตาม Team และ Employee เพื่อวนลูปสร้างแถวข้อมูล
    // Map<teamCode, Map<employeeCode, employeeInfo>>
    const groupedData = new Map<string, Map<string, SaleTeamEmployeeInfo>>();
    for (const emp of saleTeamEmployees) {
        if (!groupedData.has(emp.SaleTeamCode)) {
        groupedData.set(emp.SaleTeamCode, new Map<string, SaleTeamEmployeeInfo>());
        }
        groupedData.get(emp.SaleTeamCode).set(emp.EmployeeCode, emp);
    }

    // 5. Add row data of Excel Template
    // Loop follow sequence => Team -> Employee -> AssetType
    for (const [teamCode, employeesMap] of groupedData.entries()) { // Loop each team
        for (const [employeeCode, employeeInfo] of employeesMap.entries()) { // Loop employee in each team
        for (const assetType of assetTypes) { // Loop Asset Type in each employee
            const row: any[] = [ // <<< set row type any[]
            currentYear, // SaleTargetYear (string)
            employeeInfo.SaleTeamCode, // string
            employeeInfo.SaleTeamName, // string
            employeeInfo.EmployeeCode, // string
            employeeInfo.EmployeeName, // string
            assetType.AssetTypeCode, // string
            assetType.AssetTypeName // string
            ];

            // Add column in each month (start with 0)
            for (let i = 0; i < 12; i++) {
            row.push(0); // Set initial target to 0 in each month (Jan - Dec)
            }

            data.push(row); // Add row Array for Excel
        }
        }
    }

    // 6. Create & Download Excel File
    // Use XLSX.utils.aoa_to_sheet transform to Array of Arrays (data) as Excel Worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new(); // Create Workbook (new file Excel)
    XLSX.utils.book_append_sheet(wb, ws, "SaleTargetData"); // Add Worksheet in Workbook and create Sheet Name as "SaleTargetData"
    XLSX.writeFile(wb, `SaleTargetByProductTemplate_${currentYear}.xlsx`); // Create filename for download

    //console.log(`✅ สร้างไฟล์ SaleTargetTemplate_${currentYear}.xlsx สำเร็จ!`);
    alert(`สร้างไฟล์ SaleTargetByProductTemplate_${currentYear}.xlsx สำเร็จ!`);
  }

  public async onGenerateExcelTemplate(): Promise<void> {
  await this.LoadEmpMappingSaleTargetTeamList();
  await this.generateSaleTargetExcelTemplate();
  }

  private recalculateCustomerAggregatesForEditedValues(empCode: string, teamCode: string, customerType: 'old' | 'new'): void {
  const compositeKey = `${empCode}_${teamCode}`;
  const prefix = `${compositeKey}_${customerType}_`; // 'empCode_teamCode_old_' หรือ 'empCode_teamCode_new_'

  // Helpers to get and set values from editedValues
  const getVal = (keyPart: string) => Number(this.editedValues[prefix + keyPart] || 0);
  const setVal = (keyPart: string, value: number) => this.editedValues[prefix + keyPart] = value;

  // --- Recalculate Months (if any changes were just made by Excel, ensure they are numbers) ---
  const monthlyValues: number[] = [];
  for (let i = 0; i < 12; i++) {
    monthlyValues.push(getVal(`month_${i}`));
  }

  // --- Recalculate Quarters ---
  const quarterMap = { 'Q1': 0, 'Q2': 1, 'Q3': 2, 'Q4': 3 };
  const quarterNames = ['Q1', 'Q2', 'Q3', 'Q4'];
  for (let q = 0; q < 4; q++) {
    const startMonthIndex = q * 3;
    const quarterSum = (monthlyValues[startMonthIndex] || 0) +
                       (monthlyValues[startMonthIndex + 1] || 0) +
                       (monthlyValues[startMonthIndex + 2] || 0);
    setVal(`quarter_${q}`, quarterSum);
  }

  // --- Recalculate Year Total ---
  const yearSum = monthlyValues.reduce((sum, val) => sum + (val || 0), 0);
  setVal('year', yearSum);

  // console.log(`Recalculated aggregates for ${compositeKey} (${customerType}):`, {
  //   months: monthlyValues,
  //   q1: getVal('quarter_0'), q2: getVal('quarter_1'), q3: getVal('quarter_2'), q4: getVal('quarter_3'),
  //   year: getVal('year')
  // });
  }

  async onCustomerTargetFileChange(evt: any) {
  const target: DataTransfer = <DataTransfer>(evt.target);
  if (target.files.length !== 1) {
    alert('ไม่สามารถใช้หลายไฟล์ได้ กรุณาเลือกไฟล์เดียว.');
    // *** เพิ่มการรีเซ็ตค่าของ input file ที่นี่ ***
    if (this.customerTargetExcelFileInput && this.customerTargetExcelFileInput.nativeElement) {
      this.customerTargetExcelFileInput.nativeElement.value = '';
    }
    return;
  }

  const reader: FileReader = new FileReader();
  reader.onload = async (e: any) => {
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
    const wsname: string = wb.SheetNames[0]; // อ่านจากชีทแรก
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    // แปลงข้อมูลในชีทเป็น JSON โดยให้แถวแรกเป็น Header
    const excelData: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

    if (!excelData || excelData.length < 2) { // ต้องมีอย่างน้อย 2 แถว: header + 1 data row
      alert('รูปแบบไฟล์ Excel ไม่ถูกต้อง หรือไม่มีข้อมูล กรุณาตรวจสอบว่ามี Header และข้อมูล');
      // *** เพิ่มการรีเซ็ตค่าของ input file ที่นี่ ***
      if (this.customerTargetExcelFileInput && this.customerTargetExcelFileInput.nativeElement) {
        this.customerTargetExcelFileInput.nativeElement.value = '';
      }
      return;
    }

    const headerRow = excelData[0] as string[];
    // ทำความสะอาด Header โดยเปลี่ยนเป็น lowercase และ trim ช่องว่าง
    const cleanedHeaders = headerRow.map(header => (header ? header.trim().toLowerCase() : ''));

    // หา Index ของคอลัมน์ที่จำเป็นตามโครงสร้างไฟล์ CSV ที่ให้มา
    const yearIndex = cleanedHeaders.indexOf('saletargetyear');
    const teamCodeIndex = cleanedHeaders.indexOf('saletargetteamcode');
    const empCodeIndex = cleanedHeaders.indexOf('saletargetempcode');
    const customerTypeIndex = cleanedHeaders.indexOf('customertype'); // คอลัมน์ CustomerType

    // Header สำหรับคอลัมน์รายเดือน (Jan-Dec)
    const monthHeaders = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const monthIndices: number[] = monthHeaders.map(mh => cleanedHeaders.indexOf(mh)); // หา Index ของแต่ละเดือน

    // ตรวจสอบว่ามี Header ที่จำเป็นครบถ้วนหรือไม่
    if (yearIndex === -1 || teamCodeIndex === -1 || empCodeIndex === -1 || customerTypeIndex === -1 || monthIndices.some(idx => idx === -1)) {
      alert('ขาดคอลัมน์ Header ที่จำเป็นในไฟล์ Excel: SaleTargetYear, SaleTargetTeamCode, SaleTargetEmpCode, CustomerType, หรือคอลัมน์เดือน (Jan-Dec) บางส่วน.');
      // *** เพิ่มการรีเซ็ตค่าของ input file ที่นี่ ***
      if (this.customerTargetExcelFileInput && this.customerTargetExcelFileInput.nativeElement) {
        this.customerTargetExcelFileInput.nativeElement.value = '';
      }
      return;
    }
    
    // *** ขั้นตอนสำคัญ: เริ่มต้น originalValues และ editedValues ด้วยข้อมูลปัจจุบัน ***
    // นี่คือการเตรียม state เพื่อให้ saveTableEdit() สามารถเปรียบเทียบการเปลี่ยนแปลงได้
    this.initializeEditValues(); 
    
    let changesMade = false;

    // ประมวลผลแต่ละแถวข้อมูลใน Excel
    const dataRows = excelData.slice(1); // ข้อมูลเริ่มต้นจากแถวที่ 2 เป็นต้นไป (ไม่รวม Header)
    for (const row of dataRows) {
      const year = String(row[yearIndex] || ''); // ดึงค่าและแปลงเป็น String
      const teamCode = String(row[teamCodeIndex] || '');
      const empCode = String(row[empCodeIndex] || '');
      const customerTypeRaw = String(row[customerTypeIndex] || ''); // ดึงค่า CustomerType
      
      // แปลง CustomerType เป็น 'old' หรือ 'new' เพื่อใช้ใน Key ของ editedValues
      const customerType = customerTypeRaw.toLowerCase().includes('old') ? 'old' : 'new';

      // ตรวจสอบว่าข้อมูลหลักครบถ้วนหรือไม่ในแถวปัจจุบัน
      if (!year || !teamCode || !empCode || !customerTypeRaw) {
        console.warn(`Skipping row due to missing key data: ${JSON.stringify(row)}`);
        continue;
      }
      
      const compositeKey = `${empCode}_${teamCode}`; // สร้าง Composite Key เหมือนที่ใช้ใน initializeEditValues

      // ตรวจสอบว่ามี Employee/Team Combination นี้อยู่ใน processedTeamData ของเราหรือไม่
      let foundEmployee = false;
      // เราต้องวนลูปผ่าน processedTeamData (ข้อมูลที่แสดงบน UI) เพื่อหาตำแหน่งที่จะอัปเดต
      for (const team of this.processedTeamData) {
        if (team.teamCode === teamCode) {
          for (const emp of team.employees) {
            if (emp.empCode === empCode && emp.teamCode === teamCode) { 
              foundEmployee = true; // พบ Employee/Team ที่ตรงกัน

              // วนลูปอัปเดตค่ารายเดือนสำหรับ CustomerType ปัจจุบัน (Old หรือ New)
              for (let i = 0; i < 12; i++) {
                const monthExcelValue = Number(row[monthIndices[i]] || 0); // อ่านค่าเดือนจาก Excel
                const monthKey = `${compositeKey}_${customerType}_month_${i}`; // สร้าง Key ให้ตรงกับ editedValues
                
                // เปรียบเทียบค่าจาก Excel กับค่า original เพื่อดูว่ามีการเปลี่ยนแปลงหรือไม่
                if (monthExcelValue !== (this.originalValues[monthKey] || 0)) {
                  this.editedValues[monthKey] = monthExcelValue; // อัปเดตค่าใน editedValues
                  changesMade = true; // ระบุว่ามีการเปลี่ยนแปลง
                }
              }
              
              // *** สำคัญ: เรียกฟังก์ชัน recalculateCustomerAggregatesForEditedValues ***
              // เพื่อคำนวณยอดรวมรายไตรมาสและยอดรวมรายปีใน editedValues
              // ให้ถูกต้องตามค่าเดือนที่เพิ่งอัปเดตจาก Excel
              this.recalculateCustomerAggregatesForEditedValues(empCode, teamCode, customerType as ('old' | 'new'));
              
              break; // ออกจาก loop employees เมื่อพบแล้ว
            }
          }
        }
        if (foundEmployee) break; // ออกจาก loop teams เมื่อพบแล้ว
      }

      if (!foundEmployee) {
        // แจ้งเตือนหากไม่พบ Employee/Team combination ในข้อมูลปัจจุบัน (อาจจะหมายถึงข้อมูลใน Excel ไม่มีในระบบ)
        console.warn(`ไม่พบพนักงาน/ทีม (${empCode}, ${teamCode}) ในข้อมูลที่แสดงปัจจุบันสำหรับแถว: ${JSON.stringify(row)}. ข้ามการอัปเดตแถวนี้.`);
      }
    }

    if (!changesMade) {
      alert('ไม่พบการเปลี่ยนแปลงใดๆ จากไฟล์ Excel');
    }

    // *** เรียก saveTableEdit() โดยตรง เพื่อบันทึกการเปลี่ยนแปลง ***
    await this.saveTableEdit(); 

    // *** สำคัญ: รีเซ็ตค่าของ input file หลังจากการประมวลผลเสร็จสิ้น ***
    // เพื่อให้ change event ทำงานได้ในการอัปโหลดครั้งถัดไป
    if (this.customerTargetExcelFileInput && this.customerTargetExcelFileInput.nativeElement) {
      this.customerTargetExcelFileInput.nativeElement.value = '';
    }
  };
  reader.readAsArrayBuffer(target.files[0]);
  }

  async LoadEmpMappingSaleTargetTeamList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            })
        };

        const objectjson = {
          SaleTeamCode: this.checkUndefinedString(this.txtSearchSaleTeam)
        };

        let strjson = JSON.stringify(objectjson);

        try {
            // *** แก้ไข 3: ใช้ await ตรงๆ กับ toPromise() ***
            const data = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingSaleTargetTeam", strjson, httpOptions).toPromise();
            this.EmpMappingSaleTargetTeamList = data;

            console.log('load EmpMappingSaleTargetTeamList:', this.EmpMappingSaleTargetTeamList);
        } catch (error) {
            console.error('EmpMappingSaleTargetTeamList: Error:', error);
            this.EmpMappingSaleTargetTeamList = []; // ตั้งค่าเป็น array ว่างเปล่าเมื่อเกิดข้อผิดพลาด
        }
    } else {
        console.error('loadEmpMappingSaleTargetTeamList: Token ไม่พร้อมใช้งาน');
    }
  }

}